module.exports = __webpack_public_path__ + "static/img/brees-2007-slide-1.0f73b6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-slide-1.jpg
// module id = VRGm
// module chunks = 1